import axios from 'axios';
import { getToken } from '../auth/token';

const API_BASE_URL = 'https://api-trail-app-1.1-trail.694283.xyz';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    if (config.data) {
      config.data.access_token = token;
    } else {
      config.data = { access_token: token };
    }
  }
  return config;
});

export const apiPost = async (data) => {
  const response = await apiClient.post('/server.php', data);   // ✅ clean URL
  return response.data;
};

export default apiClient;